import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/codebuild/output/src1214854546/src/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/public/images/about/legal-betting-hero-img.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/app/(public)/(learn)/legal-state/[slug]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/global/state-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/icon.tsx");
